export const LINK_HREF = `https://support.secondstep.org/hc/en-us/articles/27652849593243-2024-25-Detailed-Program-Updates-for-Second-Step-Middle-School`
export const LINK_TEXT = 'See FAQ'
export const STATUS = 'Recognizing Bullying & Harassment Unit'
export const SUBTITLE1 = 'Change school access to ON or OFF.'
export const TITLE =
  'Recognizing Bullying & Harassment Unit Access for Grades 6-8'
